import { StaticImageData } from 'next/image';
import {
  TAnalyticEventParams,
  TOpenDrawerData,
} from '@portals/help-center-core';

export type TTool = {
  name: string;
  icon: StaticImageData;
};

export enum ESlideId {
  PIN_REVIEW = 'pinReview',
  PHOTO_MARKS = 'photoMarks',
  SEARCH_QUERIES = 'searchQueries',
  BUYER_PORTRAIT = 'buyerPortrait',
  AUTO_PLAY_VIDEO = 'autoPlayVideo',
  VIRTUAL_PHOTO_STUDIO = 'virtualPhotoStudio',
  CLOTHES_DISCOUNT_WORK = 'clothesDiscountWork',
  PRODUCT_POSITION_BOOST = 'productPositionBoost',
  ACCENT_COLORS_PRODUCT_CARD = 'accentColorsProductCard',
  DISABLE_PRICE_CHANGE_GRAPH = 'disablePriceChangeGraph',
  NICHE_ANALYSIS = 'nicheAnalysis',
  SALES_FUNNEL = 'salesFunnel',
  EVENT_CALENDAR = 'eventCalendar',
  STOCK_HISTORY_BY_REGION = 'stockHistoryByRegion',
  SEARCH_AND_PORTRAIT = 'searchAndPortrait',
  PRODUCT_CARD_COMPARISON = 'productCardComparison',
}

export enum EBlockName {
  JAM = 'jam',
  TARIFF_CONSTRUCTOR = 'tariffСonstructor',
  ANALYTICS = 'analytics',
}

export enum EContentText {
  TEXT = 'text',
  LIST = 'list',
}

export enum EModalName {
  CLOTHES_DISCOUNT_WORK = 'clothes_discount_work',
  JAM_60_DAYS_FREE = 'jam_60_days_free',
}

export enum EButtonName {
  MORE_DETAILS = 'more_details',
  DISCOUNT_WORK = 'discount_work',
  SWIPE = 'swipe',
  MORE_ABOUT_JAM = 'more_about_jam',
  REGISTER = 'register',
}

export enum EVariant {
  ORANGE = 'orange',
  BLUE = 'blue',
  TURQUOISE = 'turquoise',
}

type TCardModalBlock = {
  title: string;
  description: string;
};

export type TSlideModalContent = {
  name: EModalName;
  title: string;
  content: Array<TContentText | TContentList>;
};

type TModalLink = {
  id: EButtonName;
  text: string;
  route: string;
};

export type TCardModalContent = {
  name: EModalName;
  title: string;
  blocks: Array<TCardModalBlock>;
  link: TModalLink;
  list: TContentList;
  button: TButton;
};

export type TSlide = {
  id: ESlideId;
  title: string;
  subtitle?: string;
  description?: string;
  buttonText?: string;
  image: StaticImageData | undefined;
  modal?: TSlideModalContent;
};

export type TButton = {
  title: string;
  id?: EButtonName;
  link?: string;
};

export type TContentText = {
  type: EContentText.TEXT;
  text: string;
};

export type TContentList = {
  type: EContentText.LIST;
  title?: string;
  items: Array<string>;
};

export type TOpenDrawerParams = {
  data: TOpenDrawerData;
  buttonName: TAnalyticEventParams['buttonName'];
};

export type TCard = {
  blockName: EBlockName;
  tool?: TTool;
  title: string;
  description: Array<TContentText | TContentList>;
  button?: TButton;
  variant: EVariant;
  sliderId: number;
  slides: Array<TSlide>;
  modal?: TCardModalContent;
  trialPromoOffer?: string;
  drawer?: TOpenDrawerParams;
};

export type TPromoZoneConfig = {
  title: string;
  cards: Array<TCard>;
};
